<template>
	<div>
		<b-modal
			id="modal-prevent-closing"
			ref="modal"
			:title="getText('session_short')"
			size="md"
			centered
			hide-header-close
			hide-footer
			@hide="onHide"
		>
			<div class="text-center">
				<h4 class="mb-3">{{ getText('modal_code_title') }}</h4>
				<h1 class="display-4 border border-2 px-5 py-1" style="display: inline-block; border-radius: 100em;">{{ code }}</h1>
				<p class="mt-3 mb-0">{{ getText('modal_code_explanation') }}</p>
			</div>

			<hr />

			<div class="d-flex justify-content-between">
				<b-button v-if="showLogout" @click="logout" :variant="hasMadeProgress ? 'danger' : 'secondary'">{{ $t("logout") }}</b-button>
				<b-button @click="close" variant="primary">OK</b-button>
			</div>
		</b-modal>
	</div>
</template>



<script>
	export default {
		data() {
			return {
				code: "????",
				hasMadeProgress: false,
				showLogout: false,
			}
		},
		mounted() {
		},
		methods: {
			open(sessionCode, showLogout) {
				this.code = sessionCode;
				this.$refs.modal.show();
				this.$log.onShowModal("session_code", true);

				this.hasMadeProgress = (this.$tracker.completedTasks.length > 0);
				this.showLogout = showLogout;
			},
			close() {
				this.$refs.modal.hide();
			},
			logout() {
				if (!this.hasMadeProgress || confirm(this.$t("logout_warning"))) {
					this.$log.onLogOut();
					this.fetch(`/api/clear_session/`, data => {
						location.reload();
					});
				}
			},

			onHide() {
				this.$log.onShowModal("session_code", false);
			}
		}
	}
</script>



<style scoped>
	.justify-content-between button:only-child {
		margin-left: auto;
	}
</style>
